import * as React from "react";
const SvgSeedling = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3 2c1.384 0 2.472 0 3.35.06.888.06 1.635.186 2.329.473a7 7 0 0 1 3.788 3.788c.287.694.413 1.44.473 2.328q.015.235.024.492a7 7 0 0 1 3.225-1.903C17.11 6.991 18.205 7 20 7h2a1 1 0 0 1 1 1c0 1.795.009 2.89-.238 3.812a7 7 0 0 1-4.95 4.95c-.923.247-2.017.238-3.812.238h-1v5a1 1 0 1 1-2 0v-6c0-1.301-.003-2.234.089-3H11c-1.384 0-2.472 0-3.35-.06-.888-.06-1.635-.186-2.329-.473a7 7 0 0 1-3.788-3.788c-.287-.694-.413-1.44-.473-2.328C1 5.472 1 4.384 1 3a1 1 0 0 1 1-1zm17 7c-1.924 0-2.69.008-3.294.17a5 5 0 0 0-3.536 3.536c-.13.486-.16 1.078-.167 2.294H14c1.924 0 2.69-.008 3.294-.17a5 5 0 0 0 3.536-3.536c.13-.486.16-1.078.167-2.294zM3.003 4c.003.91.011 1.622.052 2.215.053.786.156 1.289.326 1.698a5 5 0 0 0 2.706 2.706c.409.17.912.273 1.698.326C8.58 11 9.587 11 10.996 11c-.003-.91-.01-1.621-.05-2.214-.054-.786-.157-1.289-.327-1.698A5 5 0 0 0 7.913 4.38c-.409-.17-.912-.273-1.698-.326C5.42 4 4.413 4 3.003 4",
  clipRule: "evenodd"
}));
export default SvgSeedling;
//# sourceMappingURL=Seedling.js.map